import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpComponentSectionComponent from './adpComponentSection.component';

let adpComponentSectionModule = angular.module('adpComponentSection', [
  uiRouter
])

.component('adpComponentSection', adpComponentSectionComponent)

.name;

export default adpComponentSectionModule;



// WEBPACK FOOTER //
// ./src/app/components/adpComponentSection/adpComponentSection.js